class NewsletterPopup extends HTMLElement {
    constructor() {
        super();

        this.popup = this;
        this.timeToShow = parseInt(this.popup.getAttribute('data-delay'));
        this.expiresDate = this.popup.getAttribute('data-expire');
        this.shown = false;

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));

        this.querySelector('[data-close-newsletter-popup]').addEventListener(
            'click',
            this.setClosePopup.bind(this)
        );

        this.querySelector('#ContactPopup').addEventListener(
            'submit',
            this.setClosePopup.bind(this)
        );

        // Submit-Button-Beschriftung setzen (bevor das Popup sichtbar wird)
        var submitBtn = this.querySelector('#Subscribe');
        if (submitBtn) { submitBtn.textContent = 'Anmelden'; }

        // Nur auf der Startseite ausloesen und nur, wenn noch nicht geschlossen/abonniert
        var isHome = document.body.classList.contains('template-index');
        if (isHome && this.getCookie('newsletter-popup') === '') {
            // Trigger 1: nach der konfigurierten Verzoegerung (z. B. 30s Homepage-View)
            if (!isNaN(this.timeToShow)) {
                this.timer = setTimeout(this.showPopup.bind(this), this.timeToShow);
            }
            // Trigger 2: Exit-Intent (Desktop - Cursor verlaesst das Fenster oben)
            this.exitHandler = this.onExitIntent.bind(this);
            document.addEventListener('mouseout', this.exitHandler);
        }
    }

    showPopup() {
        if (this.shown) return;
        if (this.getCookie('newsletter-popup') !== '') return;
        this.shown = true;

        document.body.classList.add('newsletter-show');
        setTimeout(() => {
            document.body.classList.add('show-newsletter-image');
        }, 700);

        if (this.timer) clearTimeout(this.timer);
        if (this.exitHandler) document.removeEventListener('mouseout', this.exitHandler);
    }

    onExitIntent(event) {
        if (this.shown) return;
        var from = event.relatedTarget || event.toElement;
        if (!from && event.clientY <= 0) {
            this.showPopup();
        }
    }

    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
    }

    getCookie(cname) {
        const name = cname + '=';
        const ca = document.cookie.split(';');

        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }

        return '';
    }

    deleteCookie(name) {
        document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    }

    setClosePopup() {
        this.setCookie('newsletter-popup', 'closed', this.expiresDate);
        document.body.classList.remove('newsletter-show');
        setTimeout(() => {
            document.body.classList.remove('show-newsletter-image');
        }, 700)
    }

    onBodyClickEvent(event){
        if ((!this.contains(event.target)) && ($(event.target).closest('[data-open-newsletter-popup]').length === 0) && document.querySelector('body').classList.contains('newsletter-show')){
            this.setClosePopup();
        }
    }
}

customElements.define('newsletter-popup', NewsletterPopup);

class NewsletterMessagePopup extends HTMLElement {
    constructor() {
        super();

        this.querySelector('[data-close-newsletter-message-popup]').addEventListener(
            'click',
            this.close.bind(this)
        );

        document.body.addEventListener('click', this.onBodyClickEvent.bind(this));
    }

    close(){
        document.body.classList.remove('newsletter-message-show');
    }

    onBodyClickEvent(event){
        if (!this.contains(event.target)){
            this.close();
        }
    }
}

customElements.define('newsletter-message-popup', NewsletterMessagePopup);